export default "__VITE_ASSET__6S8MoEkuVBBJJ3mmGTNGcA__"